import { useEffect, useRef, useState } from 'react';
import { CircleButton } from '@tmsw/powerups.ui.buttons.circle-button';
import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';
import { useStore } from '@tmsw/powerups.store';
import { usePageConfig } from '@tmsw/powerups.config.page.provider';

export const PauseButton = () => {
  const { __t } = useTranslation();
  const isPlaying = useStore((state) => state.isPlaying);
  const setPlay = useStore((state) => state.setPlay);
  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  const setIsPauseEnabled = useStore((state) => state.setIsPauseEnabled);
  const page = useStore((state) => state.currentPage);
  const [isInFocus, setIsInFocus] = useState(false);
  const pauseBtn = useRef(null);
  const currentCueMetadata = useStore((state) => state.currentCueMetadata);
  const [hidePauseBtn, setHidePauseBtn] = useState(true);
  // const videoRef = useRef<HTMLVideoElement>(
  //   document.querySelector('.video-container video')
  // );

  const { pagesMap } = usePageConfig();

  const styles = {
    height: 'var(--ui-buttons-circle-button-height)',
    width: 'var(--ui-buttons-circle-button-width)',
    zIndex: '90',
    padding: 0,
    display: 'block',
  };

  useEffect(() => {
    console.log('currentCueMetadata', currentCueMetadata);
    if (currentCueMetadata?.pauseButton === hidePauseBtn) {
      setHidePauseBtn(!currentCueMetadata?.pauseButton);
    }
  }, [currentCueMetadata, hidePauseBtn]);

  useEffect(() => {
    if (!isPauseEnabled && !isPlaying && isInFocus) {
      // if (!isPauseEnabled && !isPlaying && isInFocus) {
      const vieBtnEl: HTMLButtonElement | null =
        document.querySelector('.vie-button');
      if (vieBtnEl) {
        console.log('PauseButton :: focusing first VIEButton', vieBtnEl);
        vieBtnEl.focus(); // move focus to the first emerging VIE button when pause button disappears
      }
    }
  }, [isPauseEnabled, isPlaying, isInFocus]);

  /**
   * Current Pause Button Logic
   * @date 5/7/2023 - 3:17:02 PM
   *
   * IFF
   *    The currentPage is one of SPLASH|ONBOARDING|GAME_PLAY (i.e VIE PAGES)
   *    [AND]
   *    The pause button is enabled [OR] something isPlaying that shaint be
   */
  return (
    (page === pagesMap.SPLASH ||
      page === pagesMap.ONBOARDING ||
      page === pagesMap.GAME_PLAY) &&
    !hidePauseBtn &&
    (isPauseEnabled || isPlaying) && (
      <CircleButton
        ref={pauseBtn}
        onFocus={() => {
          setIsInFocus(true);
        }}
        onBlur={() => {
          setIsInFocus(false);
        }}
        icon={!isPauseEnabled ? 'pause' : 'play'}
        style={styles}
        ariaLabel={__t(
          isPauseEnabled
            ? 'buttons.resume.ariaLabel'
            : 'buttons.pause.ariaLabel',
          'GENERAL'
        )}
        onClick={() => {
          setIsPauseEnabled(true);
          // set to true when video is paused
          setPlay(false);
        }}
      />
    )
  );
};

export default PauseButton;
